export default {
  title: 'Activity Tags',
  title_modal: 'New tag',
  title_modal_edit: 'Editing tag',
  name: 'Name',
  color: 'Color',
  addNewButton: '+ New tag'
}
